export default [
  {
    path: '/campaign-manager/taxonomy/list',
    name: 'manage-taxonomy-list',
    component: () => import('@/views/manage/taxonomy/Planing.vue')
  },
  {
    path: '/campaign-manager/taxonomy/create',
    name: 'manage-taxonomy-create',
    component: () => import('@/views/manage/taxonomy/AddNewTaxonomy.vue')
  },
  {
    path: '/campaign-manager/media-planner',
    name: 'manage-plan',
    component: () => import('@/views/manage/media-planner/Index.vue')
  },
  {
    path: '/campaign-manager/brief-form/:briefId',
    name: 'manage-plan-briefForm',
    component: () => import('@/views/manage/media-planner/BriefFormNew.vue')
  },
  {
    path: '/campaign-manager/create-media-plan',
    name: 'manage-plan-createNewPlan',
    component: () => import('@/views/manage/media-planner/CreateNewPlan.vue')
  },
  {
    path: '/campaign-manager/create-media-plan-manual',
    name: 'manage-plan-createMediaPlanManual',
    component: () => import('@/views/manage/media-planner/create-new-plan-manual/Index.vue')
  },
  {
    path: '/campaign-manager/voice',
    name: 'manage-plan-voice',
    component: () => import('@/views/manage/media-planner/MPVoice/Index.vue')
  },
  {
    path: '/campaign-manager/ordino-table',
    name: 'manage-plan-ordinoTable',
    component: () => import('@/views/manage/media-planner/OrdinoTable.vue')
  },
  {
    path: '/campaign-manager/simple-media-planner/brief-form/:briefId/:brandIds', 
    name: 'manage-plan-simpleMediaPlanner-briefForm',
    component: () => import('@/views/manage/media-planner/simple-media-planner/Index.vue')
  },
  {
    path: '/campaign-manager/simple-media-planner/create-plan',
    name: 'manage-plan-simpleMediaPlanner-createPlan',
    component: () => import('@/views/manage/media-planner/simple-media-planner/NewPlanForm.vue'),
    meta: { enableEdit: true }
  },
  {
    path: '/campaign-manager/upload/:pageType/:folder*',
    name: 'manage-plan-documentStore',
    component: () => import('@/views/creative-upload/Index.vue')
  },
  {
    path: '/campaign-manager/performance-planner',
    name: 'manage-plan-performancePlanner',
    component: () => import('@/views/manage/media-planner/performance-planner/Index.vue')
  }

]
